import styled from 'styled-components';
import CompletedSvg from '../../assets/mytrips/completed.svg';

const CompletedIcon = styled(CompletedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CompletedIcon;
